<template>
    <main id="Patient-Information" class="page-layout-vue h-100">
        <LevelTwo :router="router" />
        <main id="Patient_Information">
            <router-view />
        </main>
    </main>
</template>

<script lang="ts" src="./Patients.ts"></script>
